import { useCallback, useEffect, useState } from "react";

export function formatCountdown(totalSeconds: number): string {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

/**
 * A plain seconds-remaining countdown, inactive (0) until `start(seconds)`
 * is called. One interval ticks for the life of the component; it's a no-op
 * once secondsLeft reaches 0, so idling costs nothing.
 */
export function useCountdown(initialSeconds = 0) {
  const [secondsLeft, setSecondsLeft] = useState(initialSeconds);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecondsLeft((current) => (current > 0 ? current - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const start = useCallback((seconds: number) => {
    setSecondsLeft(seconds);
  }, []);

  return { secondsLeft, isActive: secondsLeft > 0, start };
}
